import { toast } from 'react-toastify';

export default function clearCache(url) {
    fetch(`${url}/?__escaped_fragment__&invalidateCache=true`)
        .then((resp) => {
            if (resp.status !== 200) {
                toast.error('Не получилось очистить кэш, попробуйте сохранить материал ещё раз');
                console.error(`Clear cache Error: ${resp.status}`);
            }
        })
        .catch((err) => {
            toast.error('Не получилось очистить кэш, попробуйте сохранить материал ещё раз');
            console.error(`Clear cache Error: ${err.message}`);
        });
}
